<div class="modal-header">
  <span class="popup-title header-num">{{ configs.title }}</span>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>

<div class="modal-body">
  <div class="form-group mb-4">
    <label for="testPlanName" class="form-label general-text-6"
      >Test Plan Name</label
    >
    <input
      type="text"
      id="testPlanName"
      class="form-control"
      [formControl]="dynamicForm.get('testPlanName')"
      placeholder="Enter test plan name"
    />
  </div>

  <!-- Table placeholder - add your table here -->

  <label class="form-label general-text-6"> Selected Test Cases ({{ selectedTestCaseCount }}) </label>

  <div class="selected-chips-container mb-4" [style.display]="selectedTestCases.length === 0 ? 'none' : 'flex'">
    <div class="test-case-chip" *ngFor="let testCase of selectedTestCases">
      <span class="chip-text">{{ testCase.testCaseName }}</span>
      <button class="chip-close-btn" (click)="removeTestCase(testCase)">
        <img src="assets/images/virtusa-icons/close.svg" alt="Remove" />
      </button>
    </div>
  </div>

  <div class="info-container mb-4" *ngIf="selectedTestCases.length === 0">
    <ul>
      <li>
        Select test cases from the available Test Suite/Test Case List & ensure
        the correct version is chosen before proceeding.
      </li>
      <li>
        <strong>Set as Default:</strong> Sets the selected Execution Engine and
        Browser for all selected test cases in this test plan. May override
        existing settings.
      </li>
    </ul>
  </div>

  <label class="form-label general-text-6">
    Available Test Suite/Test Case List
  </label>

  <div class="table-div">
    <!-- Loading state while scripts are fetched -->
    <div class="accordion-loading" *ngIf="isLoading">
      <div class="accordion-spinner"></div>
      <span>Loading test cases...</span>
    </div>
    <!-- According table view TSG expandable auto-->
    <app-accordion-table-view
      *ngIf="!isLoading"
      [sections]="configs.accordionData"
      [itemLabel]="'Test Cases'"
      [paginationInfo]="configs.paginationInfoTSG"
      [sortOptions]="configs.sortOptions"
      [showHeader]="true"
      [showTestPlanHeader]="true"
      [dropdown1Options]="executionEngineOptions"
      [dropdown1Config]="{ iconType: 'assetImage', placeholderText: 'Execution Engine' }"
      [dropdown1RowKey]="'executionEngine'"
      [dropdown2Options]="browserOptions"
      [dropdown2RowKey]="'browser'"
      [showPagination]="(configs.accordionData.length || 0) > 1"
      (selectAllChange)="onSelectAllChange($event)"
      (switchToggle)="onSwitchToggle($event)"
      (dropdown1Change)="onExecutionEngineChange($event)"
      (dropdown2Change)="onBrowserChange($event)"
      (tableRowSelect)="onTableRowSelect($event.selectedRows, $event.section)"
      (tableActions)="handleTableActions($event.action, $event.section)"
    >
    </app-accordion-table-view>
  </div>
</div>

<div class="modal-footer d-flex justify-content-end">
  <button
    type="submit"
    class="btn btn-accello-secondary d-block"
    (click)="activeModal.dismiss('Cross click')"
  >
    Cancel
  </button>
  <!-- [disabled]="!dynamicForm.valid" -->
  <button
    type="submit"
    class="btn btn-accello-primary-light d-block d-flex align-items-center gap-2"
    (click)="create()"
    [disabled]="isCreating || !dynamicForm.get('testPlanName')?.value?.trim() || selectedTestCaseCount === 0"
  >
    <span *ngIf="isCreating" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    {{ isCreating ? 'Creating...' : configs.saveBtnText }}
  </button>
</div>
